import { BusinessTypes } from 'constants/businessTypes'

export const checkIsSpecialBusiness = (businessTypeId: number | null) => {
  return Object.values(BusinessTypes).includes(businessTypeId)
}
